import { useWireWithdrawController } from "./WireWithdraw.controller";
import { WireWithdrawPresentation } from "./WireWithdraw.pres";

export const WireWithdrawConnector = () => {
  const controller = useWireWithdrawController();

  return <WireWithdrawPresentation {...controller} />;
};
